// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import styles from './card.module.less';

interface i_card_props {
    amount: string;
    price: string;
    billed: string;
    bandwidth?: string;
    plan_id: string;
    type: Proxy_type;
    is_free?: boolean;
    is_popular?: boolean;
    is_sold_out?: boolean;
    is_all_sold_out?: boolean;
}

export const Card = (props: i_card_props)=>{
    const {
        amount,
        price,
        billed,
        bandwidth,
        plan_id,
        type,
        is_free = false,
        is_popular = false,
        is_sold_out = false,
        is_all_sold_out = false
    } = props;
    const {theme} = useContext(Settings_context);
    const is_disabled = is_all_sold_out || is_sold_out;
    const button_caption = is_free ? 'Try for free' : 'Buy now';
    const button_color = is_disabled ? 'transparent' :
        is_popular ? 'black' : 'transparent_black';
    let background_color = '';
    if (is_free)
        background_color = 'var(--wp--preset--color--pink-050)';
    else if (is_popular)
    {
        switch (type)
        {
            case Proxy_type.SDC:
                background_color = 'var(--wp--preset--color--blue-050)';
                break;
            case Proxy_type.DDC:
                background_color = 'var(--wp--preset--color--brown-050)';
                break;
            case Proxy_type.ISP:
            case Proxy_type.ISPPREM:
                background_color = 'var(--wp--preset--color--green-050)';
                break;
            case Proxy_type.RES:
                background_color = 'var(--wp--preset--color--purple-050)';
                break;
            default:
                background_color = 'var(--wp--preset--color--blue-050)';
        }
    }
    const card_style = background_color ?
        {backgroundColor: background_color} : {};
    return <div className={cn(
      styles.price_card,
      styles[type],
      is_disabled && styles.sold_out
    )} style={card_style}>
      <div className={styles.left_section}>
        <div className={styles.top_row}>
          <p className={cn(theme.p16, theme.med, styles.amount_text,
            is_disabled ? theme.color_n400 : theme.color_n700)}>
            {is_free ? 'FREE' : amount}
          </p>
          {is_sold_out && !is_all_sold_out &&
            <div className={styles.badge_sold_out}>
              <span className={cn(theme.p12, theme.med)}>SOLD OUT</span>
            </div>
          }
          {is_free &&
            <div className={styles.badge_free}>
              <span className={cn(theme.mono14, theme.reg, theme.color_n500)}>
                3 day plan</span>
            </div>
          }
          {is_popular && !is_disabled &&
            <div className={styles.badge_popular}>
              <span className={cn(theme.mono14, theme.med)}>Popular!</span>
            </div>
          }
        </div>
        {bandwidth &&
          <p className={cn(theme.p12, theme.reg, styles.bandwidth,
            is_disabled ? theme.color_n400 : theme.color_n600)}>
            <span>Up to</span>{' '}
            <span className={cn(theme.med, theme.p16, theme.color_n700)}>
              {bandwidth}GB{' '}
            </span>
            <span>Bandwidth</span>
          </p>
        }
        {is_free &&
          <p className={cn(theme.p12, theme.reg, styles.bandwidth,
            is_disabled ? theme.color_n400 : theme.color_n600)}>
            <span>Up to</span>{' '}
            <span className={cn(theme.med, theme.p16, theme.color_n700)}>
              100MB{' '}
            </span>
            <span>Bandwidth</span>
          </p>
        }
      </div>
      <div className={styles.separator}></div>
      <div className={styles.middle_section}>
        <div className={styles.price_display}>
          {is_free ?
            <div className={styles.price_wrapper}>
              <p className={cn(theme.p22, theme.med,
                is_disabled ? theme.color_n400 : theme.color_n700)}>
                $0
              </p>
              <p className={cn(theme.p14, theme.med,
                is_disabled ? theme.color_n400 : theme.color_n700)}>
                &nbsp;/  IP
              </p>
            </div> :
            <div className={styles.price_wrapper}>
              <p className={cn(theme.p22, theme.med,
                is_disabled ? theme.color_n400 : theme.color_n700)}>
                {price.split('/')[0].trim().startsWith('$') ?
                  price.split('/')[0].trim() :
                  `$${price.split('/')[0].trim()}`}
              </p>
              <p className={cn(theme.p14, theme.med,
                is_disabled ? theme.color_n400 : theme.color_n700)}>
                  &nbsp;/ {price.split('/')[1].trim()}
              </p>
            </div>
          }
          <p className={cn(theme.p12, theme.reg,
            is_disabled ? theme.color_n400 : theme.color_n600)}>
            {is_free ? 'No credit card required!' : billed}
          </p>
        </div>
      </div>
      <div className={styles.separator}></div>
      <div className={styles.right_section}>
        <Button
          caption={button_caption}
          color={button_color}
          round={false}
          size='xs'
          to={is_free ? '/dashboard/page/plans' :
            `/pricing/checkout?plan_id=${plan_id}`}
          cls={cn(styles.btn, is_disabled && styles.sold_out_btn)}
        />
      </div>
    </div>;
};
